import PeopleSpeakers from './PeopleSpeakers';

export { type PeopleSpeakersProps } from './PeopleSpeakers';
export default PeopleSpeakers;
